import { ProjectActivitiesConstants } from "../../constants";

export const checkCanManageActivity = (
  hasManageProjectActivityPermission: boolean,
  activityStatus?: string
): boolean => {
  return (
    hasManageProjectActivityPermission &&
    activityStatus !== ProjectActivitiesConstants.STATUS_APPROVED &&
    activityStatus !== ProjectActivitiesConstants.STATUS_SUPERSEDED &&
    activityStatus !== ProjectActivitiesConstants.STATUS_DELETED
  );
};
